/**
 * The initial shown in an avatar. A missing name (a finance account with no
 * owner, a contact with no profile) gives an empty string instead of a crash.
 */
export function formatAvatarName(name: string | null | undefined): string {
  const first = (name ?? "").trim().split(" ")[0] ?? "";

  return first.charAt(0).toUpperCase();
}
